import {classNames, layout, PushButton, typography, View} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {background} from "./background";
import {useLocalization} from "../../i18n";

interface BookingNotFoundViewProps {
    onClose: () => void;
    className?: string;
}

export function BookingNotFoundView({onClose, className}: BookingNotFoundViewProps) {
    const {t} = useLocalization();

    return (
        <View className={classNames(background, layout.vertical, layout.center, layout.alignCenter, styles.view, className)}>

            <div className={classNames(layout.vertical, layout.alignCenter, layout.paddingLarge, styles.box)}>
                <div className={classNames(typography.title, layout.marginYMedium)}>
                    {t("NoBookingsFound")}
                </div>

                <PushButton onClick={onClose}>
                    {t("Close")}
                </PushButton>
            </div>

        </View>
    )
}

const styles = stylesheet({
    view: {
        position: "relative",
    },
    box: {
        background: "rgba(64, 64, 64, 0.67)",
        width: "35em",
    },
});

